export const defaultLocales = {
    countrySelector: {
        placeholder: 'Country code',
        error: 'Choose country',
        searchPlaceholder: 'Search the country',
    },
    phoneInput: {
        placeholder: 'Phone number',
        example: 'Example:',
    },
}
